module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!!this.codeBooking) ? _c('v-layout', {
    attrs: {
      "wrap": "",
      "justify-end": "",
      "pr-4": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": "",
      "pl-2": ""
    }
  }, [_c('v-btn', {
    staticClass: "btn-save btn-success",
    on: {
      "click": _vm.goToCheckIn
    }
  }, [_vm._v("\n\t\t\t\tEditar huéspedes adicionales\n\t\t\t")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "pr-4": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md4": "",
      "pr-5": ""
    }
  }, [_c('v-select', {
    staticClass: "filter-select filter-select-main",
    attrs: {
      "items": _vm.subsidiaries,
      "item-text": "name",
      "item-value": "id",
      "label": "Sucursales",
      "hide-details": "",
      "disabled": !!_vm.codeBooking,
      "single-line": "",
      "bottom": ""
    },
    on: {
      "input": _vm.loadTypeRooms
    },
    model: {
      value: (_vm.subsidiaryId),
      callback: function($$v) {
        _vm.subsidiaryId = $$v
      },
      expression: "subsidiaryId"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "text-xs-right": ""
    }
  }, [(_vm.booking && _vm.booking.code) ? _c('h5', {
    staticClass: "code-number"
  }, [_vm._v("\n\t\t\t\tNº Reserva: " + _vm._s(_vm.booking.numReservation) + "\n\t\t\t")]) : _vm._e()])], 1), _vm._v(" "), (!!_vm.codeBooking) ? _c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "bar-data"
  }, [_c('div', {
    staticClass: "bar-data-item"
  }, [_c('p', [_vm._v("\n\t\t\t\t\t\tLlegada:\n\t\t\t\t\t\t"), _c('span', [_vm._v(_vm._s(_vm._f("parseDate")(_vm.booking.bookingStart)))])])]), _vm._v(" "), _c('div', {
    staticClass: "bar-data-item"
  }, [_c('p', [_vm._v("\n\t\t\t\t\t\tSalida:\n\t\t\t\t\t\t"), _c('span', [_vm._v(_vm._s(_vm._f("parseDate")(_vm.booking.bookingEnd)))])])]), _vm._v(" "), _c('div', {
    staticClass: "bar-data-item"
  }, [_c('p', [_vm._v("\n\t\t\t\t\t\tNoches:\n\t\t\t\t\t\t"), _c('span', [_vm._v(_vm._s(_vm.booking.numberNights))])])]), _vm._v(" "), (_vm.multiRooms) ? _c('div', {
    staticClass: "bar-data-item"
  }, [_c('p', [_vm._v("\n\t\t\t\t\t\tTipo Hab.:\n\t\t\t\t\t\t"), _c('span', [_vm._v(_vm._s(_vm.booking.room.data.roomTypes.data.name))])])]) : _vm._e(), _vm._v(" "), (_vm.multiRooms) ? _c('div', {
    staticClass: "bar-data-item"
  }, [_c('p', [_vm._v("\n\t\t\t\t\t\tNº Hab.:\n\t\t\t\t\t\t"), _c('span', [_vm._v(_vm._s(_vm.booking.room.data.codeRoom))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "bar-data-item"
  }, [_c('p', [_vm._v("\n\t\t\t\t\t\tNº Huésped:\n\t\t\t\t\t\t"), _c('span', [_vm._v(_vm._s(_vm.booking.summary.booking.guestsNumber))])])]), _vm._v(" "), _c('div', {
    staticClass: "bar-data-item"
  }, [_c('p', [_vm._v("\n\t\t\t\t\t\tPor Noche:\n\t\t\t\t\t\t"), _c('span', [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.booking.summary.promotion.currency) + "\n\t\t\t\t\t\t\t" + _vm._s(_vm.booking.ratePerDay) + "\n\t\t\t\t\t\t")])])]), _vm._v(" "), _c('div', {
    staticClass: "bar-data-item no-border"
  }, [_c('p', [_vm._v("\n\t\t\t\t\t\tTotal:\n\t\t\t\t\t\t"), _c('span', [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.booking.summary.promotion.currency) + "\n\t\t\t\t\t\t\t" + _vm._s(_vm.booking.bookingTotal) + "\n\t\t\t\t\t\t")])])])])])], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.bookings), function(booking, bookingIndex) {
    return _c('v-layout', {
      key: bookingIndex,
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "px-1": "",
        "xs12": ""
      }
    }, _vm._l((booking.rooms), function(bookingRoom, indexBookingRoom) {
      return _c('rooms-component', {
        key: indexBookingRoom,
        attrs: {
          "index": indexBookingRoom,
          "type-rooms": _vm.typeRooms,
          "booking": bookingRoom,
          "rooms": bookingRoom.availableRooms,
          "currencies": _vm.currencies,
          "pre-payment": _vm.prepaymentDisabled,
          "id-subsidiary": _vm.subsidiaryId,
          "multiple-bookings": _vm.multipleBookings,
          "code-booking": !!_vm.codeBooking
        },
        on: {
          "load-free-rooms": function($event) {
            _vm.loadFreeRooms($event, bookingIndex, indexBookingRoom)
          },
          "load-rate": function($event) {
            _vm.loadRate($event, bookingIndex, indexBookingRoom)
          },
          "total-by-booking": function($event) {
            _vm.updateTotalByBooking($event, bookingIndex, indexBookingRoom)
          },
          "delete-booking": _vm.deleteBooking,
          "edit-reservations": function($event) {
            _vm.editReservation($event, bookingIndex)
          }
        }
      })
    })), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('v-layout', {
      attrs: {
        "wrap": "",
        "align-center": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs2": "",
        "text-xs-left": ""
      }
    }, [_c('label', {
      staticClass: "label-form small"
    }, [_vm._v("Código")]), _vm._v(" "), _c('v-text-field', {
      staticClass: "input-border-inset",
      attrs: {
        "type": "text",
        "disabled": _vm.prepaymentDisabled
      },
      on: {
        "keyup": function($event) {
          _vm.validateNumReservation(booking)
        }
      },
      model: {
        value: (booking.numReservation),
        callback: function($$v) {
          booking.numReservation = $$v
        },
        expression: "booking.numReservation"
      }
    }), _vm._v(" "), (!_vm.validateNumReservation(booking)) ? _c('span', {
      staticClass: "caption red--text"
    }, [_vm._v("\n\t\t\t\t\t\tEl código debe contener una barra lateral (/) entre sus dígitos.\n\t\t\t\t\t")]) : _vm._e()], 1)], 1)], 1)], 1)
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "mt-3": "",
      "justify-space-between": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md9": ""
    }
  }, [_c('v-checkbox', {
    staticClass: "input-checkbox input-booking",
    attrs: {
      "label": "IGV - Los huéspedes extranjeros (no residentes) estarán exentos de impuestos",
      "color": "info",
      "disabled": _vm.prepaymentDisabled,
      "hide-details": ""
    },
    model: {
      value: (_vm.model.flagTaxes),
      callback: function($$v) {
        _vm.model.flagTaxes = $$v
      },
      expression: "model.flagTaxes"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md3": ""
    }
  }, [_c('v-layout', {
    staticClass: "total-amount",
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": "",
      "text-xs-right": ""
    }
  }, [_c('p', [_vm._v("Subtotal:")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": ""
    }
  }, [_c('p', [_vm._v("$" + _vm._s(_vm._f("round")(_vm.subtotalAmount)))])])], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "total-amount",
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": "",
      "text-xs-right": ""
    }
  }, [_c('p', [_vm._v("IGV:")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": ""
    }
  }, [_c('p', [_vm._v("$" + _vm._s(_vm._f("round")(_vm.taxesAmount)))])])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "md3": ""
    }
  }, [(_vm.showAditionalBook && !_vm.codeBooking) ? _c('button-create', {
    attrs: {
      "text": "Reserva Adicional",
      "btn-function": "",
      "disabled": _vm.disabledBtnCreate
    },
    on: {
      "function-click": _vm.addBookingRow
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "md3": ""
    }
  }, [_c('v-layout', {
    staticClass: "total-amount",
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": "",
      "text-xs-right": ""
    }
  }, [_c('p', [_vm._v("Total:")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": ""
    }
  }, [_c('span', [_vm._v("$" + _vm._s(_vm._f("round")(_vm.totalAmount)))])])], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "my-3": ""
    }
  }, [_c('v-divider')], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-checkbox', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip:right",
      value: ({
        html: 'Usar esta opción cuando no se tenga el documento del huésped.'
      }),
      expression: "{ html: 'Usar esta opción cuando no se tenga el documento del huésped.' }",
      arg: "right"
    }],
    staticClass: "input-checkbox input-booking generic-checkbox",
    attrs: {
      "label": "Cliente Genérico",
      "color": "info",
      "hide-details": ""
    },
    model: {
      value: (_vm.model.flagGeneric),
      callback: function($$v) {
        _vm.model.flagGeneric = $$v
      },
      expression: "model.flagGeneric"
    }
  })], 1)], 1), _vm._v(" "), (_vm.genericCustomer) ? _c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-left": "",
      "mb-2": ""
    }
  }, [_c('label', {
    staticClass: "label-title"
  }, [_vm._v("Completa los datos")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-left": ""
    }
  }, [_c('label', {
    staticClass: "label-form"
  }, [_vm._v("Nº de Tarjeta")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('v-select', {
    staticClass: "filter-select filter-select-autocomplete filter-select-indicator",
    attrs: {
      "autocomplete": "",
      "item-text": "name",
      "item-value": "id",
      "items": _vm.typeCards,
      "hide-details": "",
      "single-line": "",
      "bottom": ""
    },
    model: {
      value: (_vm.typeCard),
      callback: function($$v) {
        _vm.typeCard = $$v
      },
      expression: "typeCard"
    }
  }), _vm._v(" "), _c('v-text-field', {
    staticClass: "input-border-inset input-form-select",
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.model.cardVip),
      callback: function($$v) {
        _vm.model.cardVip = $$v
      },
      expression: "model.cardVip"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-left": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": "",
      "mb-3": ""
    }
  }, [_c('label', {
    staticClass: "label-form"
  }, [_vm._v("Tipo de identificación")]), _vm._v(" "), _c('v-select', {
    staticClass: "filter-select filter-select-autocomplete filter-select-indicator",
    attrs: {
      "autocomplete": "",
      "item-text": "code",
      "item-value": "id",
      "items": _vm.typeDocuments,
      "hide-details": "",
      "single-line": "",
      "bottom": ""
    },
    model: {
      value: (_vm.model.documentType),
      callback: function($$v) {
        _vm.model.documentType = $$v
      },
      expression: "model.documentType"
    }
  }), _vm._v(" "), _c('v-text-field', {
    staticClass: "input-border-inset input-form-select",
    attrs: {
      "type": "text"
    },
    on: {
      "blur": _vm.searchCustomer
    },
    model: {
      value: (_vm.model.numDocument),
      callback: function($$v) {
        _vm.model.numDocument = $$v
      },
      expression: "model.numDocument"
    }
  }), _vm._v(" "), (_vm.$v.model.numDocument && _vm.$v.model.numDocument.$invalid) ? _c('span', {
    staticClass: "caption red--text"
  }, [_vm._v("\n\t\t\t\t\t\tEl número de documento es requerido\n\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.$v.model.numDocument && _vm.$v.model.numDocument.$invalid &&
    _vm.$v.model.numDocument.$params.minLength) ? _c('p', {
    staticClass: "caption red--text mb-0"
  }, [_vm._v("\n\t\t\t\t\t\tEs necesario ingresar " + _vm._s(_vm.$v.model.numDocument.$params.minLength.min) + " dígitos\n\t\t\t\t\t")]) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    class: {
      'xs6': !_vm.isNaturalPerson
    },
    attrs: {
      "xs3": "",
      "mb-3": ""
    }
  }, [_c('label', {
    staticClass: "label-form"
  }, [_vm._v(_vm._s(_vm.nameLabel))]), _vm._v(" "), _c('v-text-field', {
    staticClass: "input-border-inset",
    attrs: {
      "type": "text",
      "disabled": !_vm.model.numDocument
    },
    model: {
      value: (_vm.model.name),
      callback: function($$v) {
        _vm.model.name = $$v
      },
      expression: "model.name"
    }
  }), _vm._v(" "), (_vm.$v.model.name && _vm.$v.model.name.$invalid) ? _c('span', {
    staticClass: "caption red--text"
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.nameMessage) + "\n\t\t\t\t\t")]) : _vm._e()], 1), _vm._v(" "), (_vm.isNaturalPerson) ? _c('v-flex', {
    attrs: {
      "xs3": "",
      "mb-3": ""
    }
  }, [_c('label', {
    staticClass: "label-form"
  }, [_vm._v("Apellidos")]), _vm._v(" "), _c('v-text-field', {
    staticClass: "input-border-inset",
    attrs: {
      "type": "text",
      "placeholder": "Completos",
      "disabled": !_vm.model.numDocument
    },
    model: {
      value: (_vm.model.lastname),
      callback: function($$v) {
        _vm.model.lastname = $$v
      },
      expression: "model.lastname"
    }
  }), _vm._v(" "), (_vm.$v.model.lastname && _vm.$v.model.lastname.$invalid) ? _c('span', {
    staticClass: "caption red--text"
  }, [_vm._v("\n\t\t\t\t\t\tEl apellido es requerido\n\t\t\t\t\t")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": "",
      "mb-3": ""
    }
  }, [_c('label', {
    staticClass: "label-form"
  }, [_vm._v("Correo electrónico")]), _vm._v(" "), _c('v-text-field', {
    staticClass: "input-border-inset",
    attrs: {
      "type": "email",
      "placeholder": "nombre@mail.com",
      "disabled": !_vm.model.numDocument
    },
    model: {
      value: (_vm.model.email),
      callback: function($$v) {
        _vm.model.email = $$v
      },
      expression: "model.email"
    }
  })], 1)], 1), _vm._v(" "), (_vm.genericCustomer) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": "",
      "mb-3": ""
    }
  }, [_c('label', {
    staticClass: "label-form"
  }, [_vm._v("Fecha de nacimiento")]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "pa-0": ""
    }
  }, [_c('v-text-field', {
    staticClass: "input-regular input-label-select",
    attrs: {
      "value": "Adulto",
      "hide-details": "",
      "readonly": ""
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": "",
      "py-0": "",
      "pl-0": ""
    }
  }, [_c('v-menu', {
    staticClass: "menu-date-picker",
    attrs: {
      "lazy": "",
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "disabled": !_vm.model.numDocument,
      "max-width": "290px"
    },
    on: {
      "input": _vm.changeIcon
    },
    model: {
      value: (_vm.menuBirthDate),
      callback: function($$v) {
        _vm.menuBirthDate = $$v
      },
      expression: "menuBirthDate"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Fecha de nacimiento",
      "append-icon": _vm.arrowIcon(_vm.birthDateIcon),
      "single-line": "",
      "hide-details": "",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.model.dateBirth),
      callback: function($$v) {
        _vm.model.dateBirth = $$v
      },
      expression: "model.dateBirth"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "locale": "es-PE",
      "year-icon": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.model.dateBirth),
      callback: function($$v) {
        _vm.model.dateBirth = $$v
      },
      expression: "model.dateBirth"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.isNaturalPerson) ? _c('v-flex', {
    attrs: {
      "xs3": "",
      "mb-3": ""
    }
  }, [_c('label', {
    staticClass: "label-form"
  }, [_vm._v("Estado civil")]), _vm._v(" "), _c('v-select', {
    staticClass: "filter-select filter-select-autocomplete",
    attrs: {
      "autocomplete": "",
      "item-text": "name",
      "item-value": "id",
      "items": _vm.civilStatus,
      "hide-details": "",
      "disabled": !_vm.model.numDocument,
      "single-line": "",
      "bottom": ""
    },
    model: {
      value: (_vm.model.civilStatus),
      callback: function($$v) {
        _vm.model.civilStatus = $$v
      },
      expression: "model.civilStatus"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isNaturalPerson) ? _c('v-flex', {
    attrs: {
      "xs3": "",
      "mb-3": ""
    }
  }, [_c('label', {
    staticClass: "label-form"
  }, [_vm._v("Género")]), _vm._v(" "), _c('v-select', {
    staticClass: "filter-select filter-select-autocomplete",
    attrs: {
      "autocomplete": "",
      "item-text": "name",
      "item-value": "id",
      "items": _vm.genders,
      "hide-details": "",
      "disabled": !_vm.model.numDocument,
      "single-line": "",
      "bottom": ""
    },
    model: {
      value: (_vm.model.gender),
      callback: function($$v) {
        _vm.model.gender = $$v
      },
      expression: "model.gender"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('label', {
    staticClass: "label-form"
  }, [_vm._v("País")]), _vm._v(" "), _c('v-select', {
    staticClass: "filter-select filter-select-autocomplete",
    attrs: {
      "autocomplete": "",
      "items": _vm.countries,
      "item-text": "name",
      "item-value": "id",
      "label": "Elige el país",
      "hide-details": "",
      "disabled": !_vm.model.numDocument,
      "single-line": "",
      "bottom": ""
    },
    on: {
      "input": _vm.loadCities
    },
    model: {
      value: (_vm.model.countryId),
      callback: function($$v) {
        _vm.model.countryId = $$v
      },
      expression: "model.countryId"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('label', {
    staticClass: "label-form"
  }, [_vm._v("Ciudad")]), _vm._v(" "), _c('v-select', {
    staticClass: "filter-select filter-select-autocomplete",
    attrs: {
      "autocomplete": "",
      "items": _vm.citiesByCountry,
      "item-text": "province",
      "item-value": "id",
      "hide-details": "",
      "disabled": !_vm.model.numDocument,
      "single-line": "",
      "bottom": ""
    },
    model: {
      value: (_vm.model.cityId),
      callback: function($$v) {
        _vm.model.cityId = $$v
      },
      expression: "model.cityId"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": "",
      "mb-3": ""
    }
  }, [_c('label', {
    staticClass: "label-form"
  }, [_vm._v("Teléfono")]), _vm._v(" "), _c('v-text-field', {
    staticClass: "input-border-inset",
    attrs: {
      "type": "number",
      "disabled": !_vm.model.numDocument
    },
    model: {
      value: (_vm.model.phone),
      callback: function($$v) {
        _vm.model.phone = $$v
      },
      expression: "model.phone"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "mb-3": ""
    }
  }, [_c('label', {
    staticClass: "label-form"
  }, [_vm._v("Dirección")]), _vm._v(" "), _c('v-text-field', {
    staticClass: "input-border-inset",
    attrs: {
      "type": "text",
      "disabled": !_vm.model.numDocument
    },
    model: {
      value: (_vm.model.address),
      callback: function($$v) {
        _vm.model.address = $$v
      },
      expression: "model.address"
    }
  })], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "my-3": ""
    }
  }, [_c('v-divider')], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-left": "",
      "mb-2": ""
    }
  }, [_c('label', {
    staticClass: "label-title"
  }, [_vm._v("Canal de Reserva")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md2": "",
      "text-xs-left": "",
      "mb-3": ""
    }
  }, [_c('select-button', {
    staticClass: "txt-xs-left",
    attrs: {
      "label-text": "Seleccionar vendedor",
      "item-text": "name",
      "item-value": "id",
      "items": _vm.sellers
    },
    model: {
      value: (_vm.sellerId),
      callback: function($$v) {
        _vm.sellerId = $$v
      },
      expression: "sellerId"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "md3": ""
    }
  }, [_c('v-select', {
    staticClass: "filter-select filter-select-autocomplete",
    attrs: {
      "autocomplete": "",
      "items": _vm.typeChannels,
      "item-text": "name",
      "item-value": "id",
      "label": "Tipo de Canal",
      "hide-details": "",
      "single-line": "",
      "bottom": ""
    },
    on: {
      "input": _vm.loadChannels
    },
    model: {
      value: (_vm.typeChannelId),
      callback: function($$v) {
        _vm.typeChannelId = $$v
      },
      expression: "typeChannelId"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": "",
      "md3": ""
    }
  }, [_c('v-select', {
    staticClass: "filter-select filter-select-autocomplete",
    attrs: {
      "autocomplete": "",
      "items": _vm.channels,
      "item-text": "inputSearch",
      "item-value": "id",
      "label": "Canal",
      "hide-details": "",
      "single-line": "",
      "bottom": ""
    },
    on: {
      "input": _vm.setChannelInfo
    },
    model: {
      value: (_vm.channelSelected),
      callback: function($$v) {
        _vm.channelSelected = $$v
      },
      expression: "channelSelected"
    }
  })], 1), _vm._v(" "), (_vm.flagBooking) ? _c('v-flex', {
    staticClass: "customer-rate",
    attrs: {
      "xs2": ""
    }
  }, [_c('v-btn', {
    staticClass: "btn-save mt-0",
    on: {
      "click": _vm.onShowRateModal
    }
  }, [_vm._v("Tarifario")]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-fade"
    }
  }, [(_vm.flagShowRateModal) ? _c('rate-modal', {
    staticClass: "rate-modal",
    attrs: {
      "subsidiary-id": _vm.subsidiaryId,
      "rates": _vm.rateAvailability
    },
    on: {
      "update-customer-rate": _vm.updateCustomerRate,
      "subsidiary-select": _vm.showCustomerRate
    }
  }) : _vm._e()], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "mt-2": ""
    }
  }, _vm._l((_vm.typeChannelSelected.fields), function(field, fieldIndex) {
    return _c('v-flex', {
      key: fieldIndex,
      attrs: {
        "xs4": "",
        "md3": "",
        "text-xs-left": ""
      }
    }, [_c('label', {
      staticClass: "label-form"
    }, [_vm._v(_vm._s(field.label))]), _vm._v(" "), _c(field.type, {
      tag: "component",
      class: {
        'filter-select filter-select-autocomplete':
        field.type === 'v-select',
          'input-border-inset': field.type === 'v-text-field'
      },
      attrs: {
        "item-text": field.items.itemText,
        "item-value": field.items.itemValue,
        "items": field.items.name,
        "autocomplete": field.type === 'v-select'
      },
      model: {
        value: (field[field.value]),
        callback: function($$v) {
          _vm.$set(field, field.value, $$v)
        },
        expression: "field[field.value]"
      }
    })], 1)
  }))], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "my-3": ""
    }
  }, [_c('v-divider')], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('label', {
    staticClass: "label-text"
  }, [_vm._v("Late Check Out")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('label', {
    staticClass: "label-text"
  }, [_vm._v("Late Check Out")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('label', {
    staticClass: "label-text"
  }, [_vm._v("Late Check Out")])])], 1)], 1), _vm._v(" "), (_vm.lateCheckOutIsSelected) ? _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('label', {
    staticClass: "label-form"
  }, [_vm._v("Hora")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('label', {
    staticClass: "label-form"
  }, [_vm._v("Precio")])])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('v-radio-group', {
    staticClass: "radio-check-group",
    attrs: {
      "row": ""
    },
    model: {
      value: (_vm.lateCheckOut),
      callback: function($$v) {
        _vm.lateCheckOut = $$v
      },
      expression: "lateCheckOut"
    }
  }, _vm._l((_vm.arrayLate), function(late) {
    return _c('v-radio', {
      key: late.id,
      attrs: {
        "disabled": _vm.lateCheckOutDisabled,
        "label": ((late.hour) + " - $" + (late.price)),
        "value": late
      }
    })
  }))], 1), _vm._v(" "), (_vm.lateCheckOutIsSelected) ? _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    staticClass: "input-border-inset",
    attrs: {
      "type": "text",
      "readonly": _vm.lateCheckOutDisabled
    },
    model: {
      value: (_vm.lateCheckOut.hour),
      callback: function($$v) {
        _vm.lateCheckOut.hour = $$v
      },
      expression: "lateCheckOut.hour"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    staticClass: "input-border-inset",
    attrs: {
      "type": "text",
      "readonly": _vm.lateCheckOutDisabled
    },
    model: {
      value: (_vm.lateCheckOut.price),
      callback: function($$v) {
        _vm.lateCheckOut.price = $$v
      },
      expression: "lateCheckOut.price"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('label', {
    staticClass: "label-text"
  }, [_vm._v("Early Check In")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('label', {
    staticClass: "label-text"
  }, [_vm._v("Early Check In")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('label', {
    staticClass: "label-text"
  }, [_vm._v("Early Check In")])])], 1)], 1), _vm._v(" "), (_vm.earlyCheckInIsSelected) ? _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('label', {
    staticClass: "label-form"
  }, [_vm._v("Hora")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('label', {
    staticClass: "label-form"
  }, [_vm._v("Precio")])])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('v-radio-group', {
    staticClass: "radio-check-group",
    attrs: {
      "row": ""
    },
    model: {
      value: (_vm.earlyCheckIn),
      callback: function($$v) {
        _vm.earlyCheckIn = $$v
      },
      expression: "earlyCheckIn"
    }
  }, _vm._l((_vm.arrayEarly), function(early) {
    return _c('v-radio', {
      key: early.id,
      attrs: {
        "disabled": _vm.earlyCheckinDisabled,
        "label": ((early.hour) + " - $" + (early.price)),
        "value": early
      }
    })
  }))], 1), _vm._v(" "), (_vm.earlyCheckInIsSelected) ? _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    staticClass: "input-border-inset",
    attrs: {
      "type": "text",
      "readonly": _vm.earlyCheckinDisabled
    },
    model: {
      value: (_vm.earlyCheckIn.hour),
      callback: function($$v) {
        _vm.earlyCheckIn.hour = $$v
      },
      expression: "earlyCheckIn.hour"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    staticClass: "input-border-inset",
    attrs: {
      "type": "text",
      "readonly": _vm.earlyCheckinDisabled
    },
    model: {
      value: (_vm.earlyCheckIn.price),
      callback: function($$v) {
        _vm.earlyCheckIn.price = $$v
      },
      expression: "earlyCheckIn.price"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('button-field', {
    attrs: {
      "label-text": "Cama adicional",
      "activated-button": _vm.bedSelected,
      "block-button": _vm.disabledBed
    },
    on: {
      "activate-button": _vm.selectBed
    },
    model: {
      value: (_vm.aditionalBedPrice),
      callback: function($$v) {
        _vm.aditionalBedPrice = $$v
      },
      expression: "aditionalBedPrice"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('button-field', {
    attrs: {
      "label-text": "Cuna",
      "activated-button": _vm.cribSelected,
      "block-button": _vm.disabledCrib
    },
    on: {
      "activate-button": _vm.selectCrib
    },
    model: {
      value: (_vm.cribPrice),
      callback: function($$v) {
        _vm.cribPrice = $$v
      },
      expression: "cribPrice"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-left": ""
    }
  }, [_c('label', {
    staticClass: "label-form"
  }, [_vm._v("Observaciones del huésped")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    staticClass: "input-border-inset input-textarea input-note mt-1",
    attrs: {
      "no-resize": "",
      "multi-line": "",
      "placeholder": "Escriba aquí",
      "rows": 7,
      "textarea": ""
    },
    model: {
      value: (_vm.specialRequest),
      callback: function($$v) {
        _vm.specialRequest = $$v
      },
      expression: "specialRequest"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": "",
      "mt-3": ""
    }
  }, [_c('v-checkbox', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showCheckLoyalty),
      expression: "showCheckLoyalty"
    }],
    staticClass: "input-checkbox input-booking",
    attrs: {
      "label": "Activar los puntos LOYALTY",
      "disabled": !_vm.model.email,
      "color": "info",
      "hide-details": ""
    },
    model: {
      value: (_vm.model.flagLoyalty),
      callback: function($$v) {
        _vm.model.flagLoyalty = $$v
      },
      expression: "model.flagLoyalty"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": "",
      "mt-3": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-end": ""
    }
  }, [_c('v-flex', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.checkinActive),
      expression: "checkinActive"
    }],
    attrs: {
      "xs3": ""
    }
  }, [_c('v-checkbox', {
    staticClass: "input-checkbox input-booking",
    attrs: {
      "label": "Check-in Automático",
      "color": "info",
      "hide-details": ""
    },
    model: {
      value: (_vm.flagCheckIn),
      callback: function($$v) {
        _vm.flagCheckIn = $$v
      },
      expression: "flagCheckIn"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": "",
      "pl-0": ""
    }
  }, [_c('v-btn', {
    staticClass: "btn-save",
    attrs: {
      "disabled": _vm.bookingDisabled
    },
    on: {
      "click": _vm.createBooking
    }
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.btnText) + "\n\t\t\t\t\t")])], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.roomsModalOpen) ? _c('v-dialog', {
    attrs: {
      "width": "fit-content"
    },
    model: {
      value: (_vm.roomsModalOpen),
      callback: function($$v) {
        _vm.roomsModalOpen = $$v
      },
      expression: "roomsModalOpen"
    }
  }, [_c('v-card', [_c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "mb-3": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": "",
      "md2": ""
    }
  }, [_c('select-date', {
    attrs: {
      "disabled": "",
      "placeholder": "Fecha de inicio",
      "icon": "event",
      "allowed-dates": function (date) { return _vm.isAfterMethod(date, _vm.subDaysMethod(new Date(), 2)); },
      "value": _vm.formattingDate(_vm.booking.bookingStart)
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "md2": ""
    }
  }, [_c('select-date', {
    attrs: {
      "disabled": "",
      "placeholder": "Fecha de fin",
      "allowed-dates": function (date) { return _vm.isAfterMethod(date, _vm.booking.bookingStart); },
      "value": _vm.formattingDate(_vm.booking.bookingEnd)
    }
  })], 1)], 1), _vm._v(" "), _c('date-header', {
    attrs: {
      "init-day": _vm.headerDates.initDate,
      "end-day": _vm.headerDates.endDate
    }
  }), _vm._v(" "), _vm._l((_vm.roomsByDay), function(reserve, indexReserve) {
    return _c('select-room-number', {
      key: indexReserve,
      attrs: {
        "reservation-index": indexReserve,
        "types-rooms": _vm.typeRooms,
        "subsidiary": _vm.subsidiaryId,
        "rooms-by-day": reserve,
        "rates": _vm.ratesByDayAndRoomType,
        "all-reservation": _vm.roomsByDay
      },
      on: {
        "update-rooms-selected-data": _vm.updateRoomsSelected,
        "update-reservation": _vm.updateRatesInReservation
      }
    })
  })], 2), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-layout', {
    attrs: {
      "row": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs2": "",
      "mr-4": ""
    }
  }, [_c('v-btn', {
    staticClass: "mr-0 success",
    on: {
      "click": function($event) {
        _vm.updateReservation(_vm.roomsByDay)
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\tAceptar\n\t\t\t\t\t\t")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-btn', {
    staticClass: "mr-0 cancel",
    on: {
      "click": function($event) {
        _vm.closeModal(false)
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\tCancelar\n\t\t\t\t\t\t")])], 1)], 1)], 1)], 1)], 1) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-286d23ac","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/clerkinn/bookings/New.vue
// module id = 1605
// module chunks = 1